<template>
  <div>
    <a :class="`follow_btn ${savedIndex >= 0 ? 'active' : ''}`" href="javascript:void(0);"   @click="saveData(company_id)">
      <img src="../../assets/pic/follow_btn_saved.svg" alt="" v-if="savedIndex >= 0">
      <img src="../../assets/pic/follow_btn.svg" alt="" v-else>
    </a>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import {
  POST_DELETE_BAIGUULAGA,
  POST_SAVE_BAIGUULLAGA,
} from "../../graphql/queries";
export default {
  name: "baiguullaga_folow_btn",
  props: ["company_id", "type"],
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'user',
      'baiguullaga',
    ]),
    savedIndex(){
      if(this.baiguullaga){
        let savedIndex = this.baiguullaga.findIndex(item=>item.baiguullaga_id == this.company_id);
        return savedIndex;
      } else {
        return -1;
      }
    },
  },
  methods: {
    deleteBaiguullagaData(savedItem){
      this.$apollo.mutate({mutation: POST_DELETE_BAIGUULAGA,
        variables: {
          baiguullaga_id: savedItem.id,
        }
      }).then(() =>{
        this.$store.commit("removeFromBaiguullaga",  savedItem.baiguullaga_id);
      });
    },
    saveData(company_id){
      if(this.savedIndex >= 0){
        this.deleteBaiguullagaData(this.baiguullaga[this.savedIndex])
      } else {
        this.$apollo.mutate({
          mutation:  POST_SAVE_BAIGUULLAGA,
          variables:{user_id: this.user.id, b_id: company_id,}
        }).then(({data}) => {
          this.$store.commit("addToBaiguullaga",  data.createBaiguullagaDagah);
          this.$Notice.success({
            title: this.$t("Successfully_saved"),
            desc: this.$t("Followed_organization_menu")
          });
        })
      }
    },

  },
}
</script>

<style scoped>

</style>
